import { getRequest } from '@bo-apis/axios';

const getAllSiteSimpleList = (skip = {}) =>
  getRequest(
    {
      url: `/api/v1/co/system/site/get-all-site-simple-list`,
    },
    skip
  );

const getAllSubsidiaryCompanyList = (skip = {}) =>
  getRequest(
    {
      url: `/api/v1/co/system/site/get-all-subsidiary-company-list`,
    },
    skip
  );

export default {
  getAllSiteSimpleList,
  getAllSubsidiaryCompanyList,
};
